/**
 * Component Registry for Park Paloma
 * 
 * Inherits from @vibesites-amc-preferred-theme/theme-preferred and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-amc-preferred-theme/theme-preferred/registry';
import { FlexPaymentWidget } from './components/FlexPaymentWidget';
import { FloorPlansSpecial } from './components/FloorPlansSpecial';
import { GalleryHero } from './components/GalleryHero';
import { PropertyOverview } from './components/PropertyOverview';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  FlexPaymentWidget,
  FloorPlansSpecial,
  GalleryHero,
  PropertyOverview,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
